<template>
    <div class="modal-backdrop pt-4">
      <div class="card maincard borderradius10 col-lg-3 col-md-6 mt-md-4 col-11 p-0 mx-auto" :class="{'confirmCard' :verificationSuccess}" v-if="!displayAPIerrorModal">
        <div class="modal-content border-0"  v-if="!verificationSuccess">
          <div class="modal-header borderradius10 backgroundcolor9 p-4">          
            <h5 class="modal-title fontsize18 black80 proximanova-bold ml-2 text-center" id="exampleModalLabel" >Request Verification</h5>          
            <button type="button" class="close" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body borderradius10 bodymodal11" id="accordion" :class="{'bodymodal11':workEmailVerificationScreen}">
            <div class="red fontsize14 proximanova text-center">{{ errorMessage }}</div>
              <!-- aadhar verification screen -->
              <div class="p-2 pl-4 pr-4 d-flex flex-column text-center" v-if="workEmailVerificationScreen">
                <!-- error message when users reach their daily limit -->
                  <div class="input-group d-flex flex-column text-left mt-2">
                    <label for="companyName" class="proximanova fontsize14 black required mb-1">Company Name</label>
                    <input type="text"
                        name="Company Name"
                        data-vv-scope="WorkEmailVerification"
                        id="companyName" 
                        data-vv-as="Company Name"
                        disabled
                        v-model="companyName"
                        v-validate=" 'required' "
                        required
                     class="p-2 pl-3 fontsize14 black borderradius5 borderblack60">
                     <div v-if="errors.has('WorkEmailVerification.Company Name')" class="alert-danger">{{ errors.first('WorkEmailVerification.Company Name') }}</div>
                  </div>
                  <div class="input-group d-flex flex-column text-left mt-3">
                    <label for="companyWebsite" class="proximanova fontsize14 black mb-1 required">Company Website</label>
                    <input type="text"
                        name="Company Website"
                        data-vv-scope="WorkEmailVerification"
                        id="companyWebsite" 
                        data-vv-as="Company Website"
                        v-model="companyWebsite"
                        v-validate=" 'required' "
                        class="p-2 pl-3 fontsize14 black borderradius5 borderblack60">
                     <div v-if="errors.has('WorkEmailVerification.Company Website')" class="alert-danger">{{ errors.first('WorkEmailVerification.Company Website') }}</div>
                  </div>
                  <div class="input-group d-flex flex-column text-left mt-3">
                    <label for="companyEmail" class="proximanova fontsize14 black required mb-1 required">Company Email <span class="fontsize10">(Enter Email provided by the company)</span></label>
                    <input type="text"
                        name="Company Email"
                        data-vv-scope="WorkEmailVerification"
                        id="companyEmail" 
                        data-vv-as="Company Email"
                        v-model="companyEmail"
                        v-validate="{ required:true, regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ }"
                        required
                     class="p-2 pl-3 fontsize14 black borderradius5 borderblack60">
                     <div v-if="errors.has('WorkEmailVerification.Company Email')" class="alert-danger">{{ errors.first('WorkEmailVerification.Company Email') }}</div>
                  </div>
                  <div class="fontsize14 black pt-3 text-left"><span class="proximanova-bold">Note : </span><span class="proximanova">Once Verified you will not be able to edit your info.</span></div>
              </div>
              <div class="p-2 pl-4 pr-4 d-flex flex-column text-center" v-if="workEmailOTPVerificationScreen">
                  <img src="../assets/verify_finer_print.svg" alt="verify" class="col-4 mx-auto">
                  <span class="proximanova fontsize14 black mt-3">you need to enter OTP recevied on {{companyEmail}}<br>
                   click on submit button</span>
                  <div class="d-flex flex-column mt-4">
                      <label for="aadharnumber" class="proximanova fontsize16 black">OTP</label>
                      <input type="text" 
                        id="aadharnumber" 
                        class="p-2 pl-3 fontsize16 black borderradius5 borderblack60" 
                        @input="otpRegexValidation" 
                        placeholder="XXXXXX" 
                        maxlength="6" 
                        v-model="otp">
                      <div class="text-center pt-2">
                        <span class="red proximanova-semibold fontsize12">{{Errormessage}}</span>
                      </div>
                  </div>
                  <div class="fontsize14 black pt-3"><span class="proximanova-bold">Note : </span><span class="proximanova">Please enter valid OTP. You are not allowed enter OTP more than 2 times.</span></div>
              </div>
          </div>
          <div class="modal-footer">
            <img src="../assets/uploadvideo.svg" alt="uploading" width="30px" class="img-fluid mx-auto ml-1" v-if="startLoadingAnimation">
            <button class="col-11 mr-3 btn backgroundcolor3 white borderradius20 sign-up-button" v-if="!startLoadingAnimation && workEmailVerificationScreen"  @click="verifyWorkEmail">
              <span class="button-create-font proximanova">Proceed</span>
            </button>
            <button class="col-11 mr-3 btn backgroundcolor3 white borderradius20 sign-up-button" v-if="!startLoadingAnimation && workEmailOTPVerificationScreen" @click="submitOTPBtnClicked">
              <span class="button-create-font proximanova">Submit</span>
            </button>
          </div>
        </div>
        <div class="modal-content border-0" v-if="verificationSuccess">
          <div class="modal-body borderradius10 backgroundcolorwhite p-5 text-center d-flex flex-column">
            <img src="../assets/verify_blue.svg" alt="verify" width="60px" class="mx-auto">
            <span class="mt-2 proximanova-bold fontsize24 blue">Verification is under Review</span>
            <span class="mt-2 proximanova fontsize12 black">Our verification team get back to you within 24 hours</span>
          </div>
        </div>
      </div>
      <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12 mx-auto" v-else>
        <div class="modal-content border-0 borderadius12">
          <div class="modal-body p-5 pb-5">
            <div class="d-flex flex-column text-center">
              <!-- <span class="proximanova-bold fontsize18 black">Error</span> -->
              <span class="mt-2 proximanova fontsize18 black">Something Went Wrong</span>
              <span class="mt-1 proximanova fontsize16 black60">Sorry, something went wrong there. Try again later.</span>
              <button class="backgroundcolor3 white bordernone proximanova mt-4 p-1 borderadius12" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>  
  </template>
  
  <script>
  import httpuserprofile from "@/js/http-userprofile.js";
  import sessionUtils from '@/js/session-util.js'
  import $ from 'jquery'
  export default{
     data() {
      return{
        profileId : null,
        submitBtndisabled : false,
        displayAPIerrorModal : false,
        errorMessage : null,
        //modal sections
        workEmailVerificationScreen : true,
        workEmailOTPVerificationScreen : false,
        verificationSuccess : false,
        companyName : '',
        companyEmail : null,
        companyWebsite : '',
        otp : null,
        //aadharregexvalidation
        Errormessage : null,
        startLoadingAnimation : false,
      }
    },
    props : [
        'selectedWorkExperienceObj'
    ],
    methods:{
      close(status) {
          this.$emit('closeWorkEmailVerificationmodal', status);
      },
      otpRegexValidation() {
        var regex = /^(\d\s*){6}$/g;
        var x = this.otp;
        if(regex.test(x)){
          console.log("Valid OTP");
          this.Errormessage = null
        }else{ 
          console.log("Invalid OTP");
          this.Errormessage = "Please enter valid OTP"
        }
      },
      //verify aadhar card number
      // call surpass API to get otp to the mobile number
      // once get the success response move to otp screen
      verifyWorkEmail() {
        console.log("verify work email btn clicked")
        this.$validator.validateAll("WorkEmailVerification").then((isValid) => {
            if(isValid){
                console.log('valid info')
                this.startLoadingAnimation = true;
                let obj = {
                  work_email : this.companyEmail,
                  website_url : this.companyWebsite,
                  id : this.selectedWorkExperienceObj.id,
                  profileId : sessionUtils.getUserProfileId()
                }
                console.log("final obj : ", obj)
                httpuserprofile.put('/userprofile/updateWorkExperienceVericationInfo', obj) 
                .then((response) => {
                  console.log("workemail verification response : ", response.data)
                  this.startLoadingAnimation = false;
                  if(response.data == 'OTP has successfully sent to work email.'){
                    this.workEmailVerificationScreen = false;
                    this.workEmailOTPVerificationScreen = true;
                  }else{
                    this.errorMessage = response.data;
                  }
                }).catch((e) => {
                  console.log(e.response.data)
                  this.errorMessage = e.response.data;
                  this.startLoadingAnimation = false
                })
            }
        })
      },
      submitOTPBtnClicked() {
        console.log("otp verification btn clicked")
        if(!this.Errormessage){
          let obj = {
            otp : this.otp,
            id : this.selectedWorkExperienceObj.id,
            profileId : sessionUtils.getUserProfileId()
          }
          console.log("final otp verification obj : ", obj)
          httpuserprofile.put('/userprofile/verifyotp', obj) 
          .then((response) => {
            console.log("otp verification response : ", response.data)
            this.startLoadingAnimation = false;
            if(response.data.errorCode == 1005){
              this.verificationSuccess = true;
              setTimeout(() => {
                this.close('SUCCESS')
              }, 5000)
            }else{
              this.errorMessage = response.data.errorMessage;
            }
          }).catch((e) => {
            console.log(e)
            this.startLoadingAnimation = false
          })
        }
      },
    },
     mounted() {
      this.profileId=sessionUtils.getUserProfileId();
      this.companyName = this.selectedWorkExperienceObj.companyDetails.companyName;
      console.log("selected workexp for verification : ", this.selectedWorkExperienceObj)
    },
  
  }
  
  </script>
  
  <style scoped>
  @import '../css/modal.css';
  </style>